import { calendarDaysBetweenTashkent } from '@ayub/shared'

/**
 * Sana ko'rsatish yordamchilari — bloger/video kartochkalari uchun.
 *
 * `@ayub/shared`'da faqat pul/son formatlagichlar bor (`format.ts`), sana ko'rsatish
 * (`docs/04-ui-ux.md` "Raqam formati") esa WebApp'ga xos — shuning uchun bu yerda,
 * shared paketni tegmasdan.
 */

const MONTHS_FULL_UZ = [
  'yanvar',
  'fevral',
  'mart',
  'aprel',
  'may',
  'iyun',
  'iyul',
  'avgust',
  'sentabr',
  'oktabr',
  'noyabr',
  'dekabr',
]

const MONTHS_SHORT_UZ = [
  'yan',
  'fev',
  'mar',
  'apr',
  'may',
  'iyun',
  'iyul',
  'avg',
  'sen',
  'okt',
  'noy',
  'dek',
]

/**
 * `docs/04-ui-ux.md` qoidasiga mos: joriy yilda — to'liq oy nomi, yil ko'rsatilmaydi
 * (`12-yanvar`); o'tgan yillarda — qisqartirilgan oy + yil (`12-yan 2025`).
 */
export function formatDateUz(input: string | Date, now: Date = new Date()): string {
  const date = typeof input === 'string' ? new Date(input) : input
  const day = date.getDate()

  if (date.getFullYear() === now.getFullYear()) {
    return `${day}-${MONTHS_FULL_UZ[date.getMonth()] ?? ''}`
  }
  return `${day}-${MONTHS_SHORT_UZ[date.getMonth()] ?? ''} ${date.getFullYear()}`
}

/** Izohlar ro'yxati uchun nisbiy vaqt — "5 daqiqa oldin", "kecha", 7 kundan keyin sanaga o'tadi. */
export function formatRelativeUz(input: string | Date, now: Date = new Date()): string {
  const date = typeof input === 'string' ? new Date(input) : input
  const diffMs = now.getTime() - date.getTime()

  if (diffMs < 0) return formatDateUz(date, now)

  const diffMin = Math.floor(diffMs / 60_000)
  if (diffMin < 1) return 'hozir'
  if (diffMin < 60) return `${diffMin} daqiqa oldin`

  const diffHour = Math.floor(diffMin / 60)
  if (diffHour < 24) return `${diffHour} soat oldin`

  const days = calendarDaysBetweenTashkent(date, now)
  if (days === 1) return 'kecha'
  if (days > 1 && days < 7) return `${days} kun oldin`

  return formatDateUz(date, now)
}
